import React, { useContext, useEffect, useState } from "react";
import "./pricelistContent.css";
import { DataContext } from "../../App";

function PriceListContent(props: any) {
  const { pricelist, pricelistPage } = useContext(DataContext);
  const [openSections, setOpenSections] = useState<Record<string, boolean>>({});

  useEffect(() => {
    if (!pricelist) return;
    const initialState = pricelist.reduce((acc: Record<string, boolean>, section: any) => {
      acc[section.header] = false;
      return acc;
    }, {});
    setOpenSections(initialState);
  }, [pricelist]);

  const toggleSection = (header: string) => {
    setOpenSections((prev) => ({
      ...prev,
      [header]: !prev[header],
    }));
  };


  return (
    <>
      <div className="PriceListPage">
        <h1>{pricelistPage.header}</h1>
        {pricelistPage.description && <p>{pricelistPage.description}</p>}

        <div className="pricelist-buttons-container">
          {pricelist?.map((section: any) => (
            <a href={`#${section.header}`} key={section.header} onClick={() => !openSections[section.header] && toggleSection(section.header)}>
              <button className="pricelist-section-button">
                {section.header}
              </button>
            </a>
          ))}
        </div>

        {pricelist?.map((section: any) => (
          <div className="pricelist-section" key={section.header} id={section.header}>
            <h2
              className="pricelist-section-toggle"
              onClick={() => toggleSection(section.header)}
             
            >
              {section.header}
              <span className="toggle-icon" aria-hidden="true">
                {openSections[section.header] ? " -" : " +"}
              </span>
            </h2>

            {openSections[section.header] && (
              <>
                {section.description && <p>{section.description}</p>}
                <div className="pricelist-table-container">
                  <table className="pricelist-table">
                    <colgroup>
                      <col />
                      <col />
                    </colgroup>
                    <tbody>
                      {section.items && section.items.map((item: any) => (
                        <tr key={item.name}>
                          <td>{item.name}</td>
                          <td className="price-cell">{item.price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        ))}
        <div>
          {pricelistPage.footerDescription && (
            <p>{pricelistPage.footerDescription}</p>
          )}
        </div>
      </div>
    </>
  );
}

export default PriceListContent;
